// /src/hooks/useTheme.js
import { useMemo, useEffect } from 'react';

export function useThemeVars(isDark) {
  return useMemo(
    () =>
      isDark
        ? {
            '--bg': '#1e2630',
            '--bg2': '#222b36',
            '--card': '#2f3b49',
            '--border': '#3c4a5a',
            '--text': '#f1f4f8',
            '--muted': '#9aacb8',
            '--accent': '#0abfda',
            '--accent-2': '#c1e86f',
            '--tag-bg': 'rgba(255,255,255,0.06)',
            '--tag-text': '#cfe2f3'
          }
        : {
            '--bg': '#f5f7f9',
            '--bg2': '#eef2f6',
            '--card': '#ffffff',
            '--border': '#d8e1ea',
            '--text': '#1a1f26',
            '--muted': '#4b5b6b',
            '--accent': '#0abfda',
            '--accent-2': '#88c346',
            '--tag-bg': 'rgba(10,191,218,0.12)',
            '--tag-text': '#0f4c5c'
          },
    [isDark]
  );
}

export function useFullViewportBackground(themeVars, deps = []) {
  useEffect(() => {
    document.documentElement.style.height = '100%';
    document.body.style.height = '100%';
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.documentElement.style.background = themeVars['--bg'];
    document.body.style.background = themeVars['--bg'];
    document.body.style.color = themeVars['--text'];
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}